import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../utils/api';

export const ADD_NEW_SCHOOL = 'ADD_NEW_SCHOOL';
export const DELETE_SCHOOL = 'DELETE_SCHOOL';
export const GET_SCHOOLS = 'GET_SCHOOLS';

export default function schools(
  state = {
    schools: [],
    schoolList: [],
  },
  { payload, type }
) {
  switch (type) {
    case ADD_NEW_SCHOOL: {
      const { school } = payload;
      return {
        ...state,
        schools: [...state.schools, school],
      };
    }
    case DELETE_SCHOOL: {
      const { schoolID } = payload;
      return {
        ...state,
        schools: state.schools.filter((school) => school.id !== schoolID),
      };
    }
    case `${GET_SCHOOLS}_PENDING`:
      return {
        ...state,
      };
    case `${GET_SCHOOLS}_FULFILLED`:
      return {
        ...state,
        schoolList: payload.body,
        schoolListError: false,
      };
    case `${GET_SCHOOLS}_REJECTED`:
      return {
        ...state,
        schoolList: [],
        schoolListError: true,
      };
    default:
      return state;
  }
}

export const addNewSchoolToStore = (school) => {
  return (dispatch) => {
    const action = createAction(ADD_NEW_SCHOOL)({ school });
    dispatch(action);
  };
};

export const deleteSelectedSchoolFromSchools = (schoolID) => {
  return (dispatch) => {
    const action = createAction(DELETE_SCHOOL)({ schoolID });
    dispatch(action);
  };
};

export const getSchoolsList = () => {
  return (dispatch) => {
    const action = createAction(GET_SCHOOLS)(
      callApi(getEndpoint('getSchools'))
    );
    dispatch(action);
  };
};
